module.exports = __webpack_public_path__ + "static/media/doctor.87e2fe11.jpg";